import React from 'react'
import Product from './Product';
import Header from './Header';
import { information , product , paymentInfo} from './modal';
import './Style/Invoice.css'
import Footer from './Footer';

function Invoice() {

  let total = product.info.reduce((sum, item) => sum + parseInt(item.price) * item.qty, 0)
  let discount = (product.info.reduce((sum, item) => sum + parseInt(item.price) * item.qty, 0) * product.discount/100)  
  let lastPrice = total - discount

  
  var today = new Date();
  var date = today.getFullYear()+' - '+(today.getMonth()+1)+' - '+today.getDate();


  return <div className='invoice'>


      <Header date={date} productNumber={product}/>
      <Product data={product.info} />
      <Footer data={paymentInfo} product={product} discount={discount} total={total} lastPrice={lastPrice} />

      {/* <div className='container'>

          <div className='row'>

            <div className='col-md-4 left-side'>
                  <Image />
                  <Info data={information}/>
            </div>

            <div className='col-md-8 right-side'>
                  <CompanyInfo data={information}/>
                  <Product data={product.info} DateDay={date}/>
                  <Report 
                    subTotal={total}
                    discount={discount}
                    lastPrice={lastPrice}
                    product={product}
                  />
            </div>

          </div>
      </div> */}
  </div>
}

export default Invoice